export default __webpack_public_path__ + "static/media/SNP500.0e9f0110.png";